<template>
  <div class="flex flex-col h-full">
    <div class="border-0 border-b border-gray-200 border-solid">
      <HeaderWrapper
        ref="header-wrapper"
        :show-field="true"
        :show-filter="false"
        :show-footer="false"
      >
        <template #header>
          <div
            class="font-bold truncate flex items-center w-full pl-6"
            style="font-size: 17px; min-width: 250px"
          >
            Пользователи · {{ users.length }}
          </div>
        </template>
        <template #field>
          <div class="flex flex-wrap items-center justify-end gap-3 p-4">
            <el-select
              v-model="filters.type"
              @change="getUsers"
              placeholder="Статус"
              clearable
              filterable
              style="max-width: 200px"
            >
              <el-option
                v-for="opt in statusOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>
            <el-select
              v-model="filters.typeAccount"
              @change="getUsers"
              placeholder="Тип аккаунта"
              clearable
              filterable
              style="max-width: 200px"
            >
              <el-option
                v-for="opt in accountTypeOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>
            <el-input
              v-model="filters.search"
              @change="getUsers"
              placeholder="Имя, фамилия или email"
              clearable
              style="max-width: 200px"
            ></el-input>
            <el-button type="primary" plain @click="createUser">
              Создать
            </el-button>
          </div>
        </template>
      </HeaderWrapper>
    </div>
    <main class="p-6 flex-1 min-h-0 flex flex-col overflow-hidden">
      <div class="flex-1 min-h-0 flex flex-col">
        <SkeletonView
          v-if="loading"
          :column="17"
          :row="12"
          size-table="large"
        />
        <el-table
          v-else
          border
          stripe
          class="h-full"
          height="100%"
          style="overflow-y: auto; height: 100%"
          @row-click="viewUser"
          :data="users"
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            type="index"
            label="N"
            width="60"
            align="center"
          ></el-table-column>
          <el-table-column prop="first_name" label="Имя"></el-table-column>
          <el-table-column prop="last_name" label="Фамилия"></el-table-column>
          <el-table-column prop="email" label="Email"></el-table-column>
          <el-table-column prop="roles" label="Роли"></el-table-column>
          <el-table-column label="Действия" align="center">
            <template v-slot="scope">
              <el-button
                circle
                @click.stop.prevent="changePasswordUser(scope.row._id)"
              >
                <svg
                  class="ov-icon"
                  aria-hidden="true"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#222F3D"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  ></path>
                </svg>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </main>
    <el-dialog
      v-model="passwordChangeShow"
      title="Заменить пароль"
      width="600px"
    >
      <el-form label-position="top">
        <el-form-item label="Введите пароль">
          <el-input type="password" show-password v-model="form.password">
          </el-input>
        </el-form-item>
        <el-form-item label="Повторите пароль">
          <el-input
            v-model="form.confirmPassword"
            show-password
            type="password"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="mt-3 text-right">
        <el-button
          :disabled="
            form.password &&
            form.confirmPassword &&
            form.password !== form.confirmPassword
          "
          @click="updatePassword"
          type="primary"
          >Поменять пароль</el-button
        >
      </div>
    </el-dialog>
    <router-view @refetch-users="getUsers"></router-view>
  </div>
</template>

<script>
import { changeUserPassword, getUsers } from "@/api/users";
import HeaderWrapper from "@/components/HeaderWrapper.vue";
import SkeletonView from "@/components/skeleton/SkeletonView.vue";
export default {
  components: {
    SkeletonView,
    HeaderWrapper,
  },
  data() {
    return {
      users: [],
      loading: false,
      form: {
        id: null,
        password: null,
        confirmPassword: null,
      },
      filters: {
        type: null,
        typeAccount: null,
        search: "",
      },
      debounce: null,
      showingInputs: {
        password: false,
        confirmPassword: false,
      },
      passwordChangeShow: false,
    };
  },
  computed: {
    userId() {
      return this.$route.params.userId;
    },
    user() {
      return this.users.find((u) => u._id === this.userId);
    },
    statusOptions() {
      return [
        { label: "Действующие", value: 1 },
        { label: "Удаленные", value: -1 },
      ];
    },
    accountTypeOptions() {
      return [
        { label: "Верификатор", value: "verifier" },
        { label: "Разметчик", value: "annotator" },
        { label: "Админ", value: "admin" },
      ];
    },
  },
  async created() {
    await this.getUsers();
  },
  methods: {
    async getUsers() {
      let filters = this.getFilters();
      this.loading = true;
      try {
        this.users = await getUsers(filters);
      } catch (e) {
        this.users = [];
      } finally {
        this.loading = false;
      }
    },
    getFilters() {
      let params = {};
      if (this.filters.typeAccount) {
        params.role = this.filters.typeAccount;
      }
      if (this.filters.type) {
        params.status = this.filters.type;
      }
      if (this.filters.search) {
        params.search = this.filters.search;
      }
      return params;
    },
    viewUser(row) {
      this.$router.push({ name: "user-view", params: { userId: row._id } });
    },
    createUser() {
      this.$router.push({ name: "user-view", params: { userId: "new" } });
    },
    tableRowClassName({ row }) {
      if (row.status === -1) {
        return "warning-row";
      }
      return "";
    },
    changePasswordUser(id) {
      console.log(id);
      this.passwordChangeShow = true;
      this.form.id = id;
    },
    async updatePassword() {
      let data = await changeUserPassword(this.form.id, this.form.password);
      if (data._success) {
        this.passwordChangeShow = false;
        this.form.id = null;
        this.form.password = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-table .bg-blue-50 {
  background: rgba(239, 246, 255, 1);
}
::v-deep(.el-table__header th.el-table__cell) {
  @apply bg-gray-50 text-gray-600;
}
</style>
